import { Platform, StyleSheet } from 'react-native'

import { theme } from '../../../../theme'

export const ageVerificationPromptStyles = StyleSheet.create({
  modalOuter: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
  },
  sheet: {
    width: '100%',
    maxWidth: 420,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: theme.gray[700],
    backgroundColor: '#111827',
    paddingHorizontal: 20,
    paddingVertical: 20,
    gap: 12,
    ...(Platform.OS === 'android' ? { elevation: 8 } : {}),
  },
  title: {
    color: theme.white,
    fontSize: 20,
    fontWeight: '700',
  },
  body: {
    color: theme.gray[400],
    fontSize: 15,
    lineHeight: 22,
  },
  confirmDate: {
    color: theme.white,
    fontSize: 24,
    fontWeight: '700',
    marginVertical: 4,
  },
  fieldsRow: {
    flexDirection: 'row',
    gap: 10,
    marginTop: 4,
  },
  field: {
    flex: 1,
    gap: 6,
  },
  fieldYear: {
    flex: 1.6,
    gap: 6,
  },
  fieldLabel: {
    color: theme.gray[400],
    fontSize: 12,
    fontWeight: '600',
  },
  input: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: theme.gray[700],
    backgroundColor: '#1B2436',
    color: theme.white,
    fontSize: 18,
    fontWeight: '600',
    paddingVertical: 12,
    paddingHorizontal: 12,
    textAlign: 'center',
  },
  inputDisabled: {
    opacity: 0.6,
  },
  error: {
    color: theme.error,
    fontSize: 14,
  },
  primaryButton: {
    backgroundColor: theme.primary,
    borderRadius: 12,
    paddingVertical: 14,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
  },
  primaryButtonDisabled: {
    opacity: 0.6,
  },
  primaryButtonText: {
    color: theme.white,
    fontSize: 16,
    fontWeight: '700',
  },
  secondaryButton: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.gray[700],
    paddingVertical: 14,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
  },
  secondaryButtonText: {
    color: theme.white,
    fontSize: 16,
    fontWeight: '600',
  },
})
